import { type MenuActionItem, type MenuItem, type MenuRow } from './menu.types';

export const SHEET_ITEM_SELECTOR = 'button:not(:disabled)';

function isVisible(item: MenuActionItem): boolean {
  return item.visible !== false;
}

export function moveSheetFocus(root: HTMLElement, key: string): boolean {
  const items = Array.from(root.querySelectorAll<HTMLButtonElement>(SHEET_ITEM_SELECTOR));
  const currentIndex = items.findIndex((item) => item === root.ownerDocument.activeElement);
  const lastIndex = items.length - 1;

  let nextIndex = 0;

  switch (key) {
    case 'Home':
      nextIndex = 0;
      break;
    case 'End':
      nextIndex = lastIndex;
      break;
    case 'ArrowDown':
      nextIndex = currentIndex >= lastIndex ? 0 : currentIndex + 1;
      break;
    case 'ArrowUp':
      nextIndex = currentIndex <= 0 ? lastIndex : currentIndex - 1;
      break;
    default:
      return false;
  }

  items[nextIndex]?.focus();

  return true;
}

function collapseSeparators(rows: readonly MenuRow[]): readonly MenuRow[] {
  return rows.filter((row, index) => {
    if (row.kind !== 'separator') return true;

    const previous = rows[index - 1];

    if (!previous || previous.kind === 'separator') return false;

    return rows.slice(index + 1).some((next) => next.kind !== 'separator');
  });
}

export function buildRows(items: readonly MenuItem[]): readonly MenuRow[] {
  const rows: MenuRow[] = [];

  items.forEach((entry, index) => {
    if (entry.kind === 'separator') {
      rows.push({ id: `separator-${index}`, kind: 'separator' });

      return;
    }

    if (entry.kind === 'group') {
      const visibleItems = entry.items.filter(isVisible);

      if (!visibleItems.length) return;

      rows.push({
        id: `title-${entry.titleKey}`,
        kind: 'title',
        titleKey: entry.titleKey,
        titleParams: entry.titleParams,
        actionLabelKey: entry.actionLabelKey,
        actionLabelParams: entry.actionLabelParams,
        actionValue: entry.actionValue,
        actionIcon: entry.actionIcon,
      });

      for (const item of visibleItems) {
        rows.push({ id: `item-${item.value}`, item, kind: 'item' });
      }

      return;
    }

    if (!isVisible(entry)) return;

    rows.push({ id: `item-${entry.value}`, item: entry, kind: 'item' });
  });

  return collapseSeparators(rows);
}
